<app-sender-shepherd></app-sender-shepherd>
<ng-snotify></ng-snotify>
<div style="opacity: 0" class="app-root">
  <div *ngIf="themeService?.activeBackground" class="bg no-invert">
    <img loading="lazy" class="w-100 h-100" src="{{ themeService.activeBackground?.src }}" alt="" />
  </div>

  <div
    [class.chat-open]="(interfaceService.isCloseChat$ | async) === false"
    style="font-size: {{ settingsService.arConfig?.font_size?.value }}%;"
    (click)="allService.download()"
    id="routerOutlet"
    class="w-100"
  >
    <router-outlet #outlet="outlet"></router-outlet>
    <!--    <ngx-audio-player *ngIf="msaapPlaylist?.length > 0" [class.has-playlist]="msaapDisplayPlayList" [playlist]="msaapPlaylist" [displayTitle]="msaapDisplayTitle" [autoPlay]="msaapAutoPlay"
															muted="muted" [displayPlaylist]="msaapDisplayPlayList" [pageSizeOptions]="msaapPageSizeOptions"
															[displayArtist]="msaapDisplayArtist" [displayDuration]="msaapDisplayDuration"
															[expanded]="true" (trackEnded)="onEnded($event)" [displayVolumeControls]="msaapDisplayVolumeControls" [displayRepeatControls]="msaapDisplayRepeatControls"
															[disablePositionSlider]="msaapDisablePositionSlider">!!!</ngx-audio-player>-->
  </div>
</div>
